import { render } from "./ExportarAtivas.vue?vue&type=template&id=87c6fbc4"
import script from "./ExportarAtivas.vue?vue&type=script&lang=js"
export * from "./ExportarAtivas.vue?vue&type=script&lang=js"
script.render = render

export default script